import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import { LoginProvider } from "../../shared/providers/login.provider";
import { ToastsManager } from "ng2-toastr";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('cardToggle', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('500ms ease-in-out')
            ])
        ]),
        trigger('cardToggleInverse', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('50ms ease-in-out')
            ])
        ])
    ]
})
export class LoginComponent implements OnInit {
    public credentials = {
        username: '',
        password: ''
    };

    loading:boolean;
    menuType: string;
    headerType: string;
    sidebarType: string;
    themeType: string;
    toggledArrow: string;
    windowHeight: number;
    windowWidth: number;
    settingToggle: string;
    cardToggle = 'collapsed';

    constructor(private authService: AuthService,
        private router: Router,
        private loginProvider: LoginProvider,
        private tostr: ToastsManager) {
        this.themeType = 'default';
        this.toggledArrow = 'icon-arrow-left-circle';
        this.settingToggle = 'off';
        this.windowHeight = window.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        }
        if (this.windowWidth < 768) {
            this.toggledArrow = 'fa fa-bars';
        }
    }

    ngOnInit() {
    }

    onResize(event) {
        this.windowHeight = event.target.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        } else {
            this.menuType = '';
        }

        if (this.windowWidth < 768) {
            this.toggledArrow = this.menuType === 'mini-sidebar show-sidebar' ? 'fa fa-close' : 'fa fa-bars';
        } else {
            this.toggledArrow = this.menuType === 'mini-sidebar' ? 'fa fa-bars' : 'icon-arrow-left-circle';
        }
    }

    async onClickOauth(){
       window.location.href = await this.authService.oauthOffice365();
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            //this.onClickOauth();
        }

    }

    toggleCard() {
        this.cardToggle = this.cardToggle === 'collapsed' ? 'expanded' : 'collapsed';
    }

    async login() {
        this.loading = true;
        try {
            var res = await this.authService.auth(this.credentials);
            if (res.success) {
                this.loginProvider.loggedIn();
                if (this.loginProvider.isLoggedIn()) {
                    await this.router.navigateByUrl('/home');
                    this.loading = false;
                    this.tostr.success("Login realizado com sucesso.", "Seja bem-vindo!")
                }
            } else {
                this.loading = false;
                this.tostr.error(res.message, "Não foi possível realizar o login!");
            }
        } catch (err) {
            this.tostr.error("Não foi possível realizar o login!")
            console.error(err);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts